var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?[_c('v-main-header'),_c('router-view'),(!_vm.cookiesAccepted)?_c('v-cookies-banner',{on:{"accepted":function($event){_vm.cookiesAccepted = true}}}):_vm._e()]:_c('v-loader')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }